<div class="content-container">
  <h1>{{pageTitle}}</h1>

  <div class="about">
    <p [innerHTML]="pageAbout"></p>
  </div>

  <ng-container *ngIf="getActiveIndex() === SchemaButton.PRIMARY">
    <section
      class="method-step"
      *ngFor="let step of methodSteps; let first = first"
    >
      <h2>{{ step.heading }}</h2>
      <p *ngFor="let paragraph of step.paragraphs">{{ paragraph }}</p>

      <div class="index-buttons-wrapper" *ngIf="first">
        <div class="index-buttons" (click)="handleLinkButtonsClick(SchemaButton.LEFT)">
          <span>Health Index</span>
          <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.25 1.5L8.75 9L1.25 16.5" stroke="#02A4FF" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="index-buttons" (click)="handleLinkButtonsClick(SchemaButton.MIDDLE)">
          <span>Wealth Index</span>
          <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.25 1.5L8.75 9L1.25 16.5" stroke="#02A4FF" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="index-buttons" (click)="handleLinkButtonsClick(SchemaButton.RIGHT)">
          <span>Education Index</span>
          <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.25 1.5L8.75 9L1.25 16.5" stroke="#02A4FF" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </section>
  </ng-container>

  <div class="text-container">
    <ng-container *ngFor="let content of contentsArray; let i = index" >
      <mat-expansion-panel [expanded]="activeTertiaryButtons.includes(content.key)" class="mat-elevation-z0">
        <mat-expansion-panel-header  (click)="handleExpansionPanelClick(content.key)">
          <mat-panel-title class="text-content-title" [ngClass]="activeTertiaryButtons.includes(content.key) ? 'title-active' : ''">
            {{content.key}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p class="text-content" [innerHTML]="content.value"></p>
      </mat-expansion-panel>
      <mat-divider  *ngIf="getActiveIndex() !== SchemaButton.PRIMARY && i < contentsArray.length - 1"></mat-divider>
    </ng-container>

  </div>

  <p class="text-footer" *ngIf="pageFooter">
    {{pageFooter}}
  </p>
</div>
